module.exports = __webpack_public_path__ + "media/images/vedett_allatok/vedett3-3cf699ec9cca1daf1311df82dcf1dffc.jpg";